/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Use_The_Direct_Link_Below_ToInputs */

const en_use_the_direct_link_below_to = /** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the direct link below to share this listing privately even if it's hidden from your storefront.`)
};

const id_use_the_direct_link_below_to = /** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gunakan tautan langsung di bawah untuk membagikan listing ini secara pribadi meskipun disembunyikan dari etalase Anda.`)
};

/** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */
const es_use_the_direct_link_below_to = en_use_the_direct_link_below_to;

/** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */
const fr_use_the_direct_link_below_to = en_use_the_direct_link_below_to;

/** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */
const de_use_the_direct_link_below_to = en_use_the_direct_link_below_to;

/** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */
const ja_use_the_direct_link_below_to = en_use_the_direct_link_below_to;

/** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */
const zh_use_the_direct_link_below_to = en_use_the_direct_link_below_to;

/** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */
const ar_use_the_direct_link_below_to = en_use_the_direct_link_below_to;

/** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */
const it_use_the_direct_link_below_to = en_use_the_direct_link_below_to;

/** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */
const ru_use_the_direct_link_below_to = en_use_the_direct_link_below_to;

/** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */
const pt_use_the_direct_link_below_to = en_use_the_direct_link_below_to;

/** @type {(inputs: Use_The_Direct_Link_Below_ToInputs) => LocalizedString} */
const ko_use_the_direct_link_below_to = en_use_the_direct_link_below_to;

/**
* | output |
* | --- |
* | "Use the direct link below to share this listing privately even if it's hidden from your storefront." |
*
* @param {Use_The_Direct_Link_Below_ToInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const use_the_direct_link_below_to = /** @type {((inputs?: Use_The_Direct_Link_Below_ToInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Use_The_Direct_Link_Below_ToInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_use_the_direct_link_below_to(inputs)
	if (locale === "es") return es_use_the_direct_link_below_to(inputs)
	if (locale === "fr") return fr_use_the_direct_link_below_to(inputs)
	if (locale === "de") return de_use_the_direct_link_below_to(inputs)
	if (locale === "ja") return ja_use_the_direct_link_below_to(inputs)
	if (locale === "zh") return zh_use_the_direct_link_below_to(inputs)
	if (locale === "ar") return ar_use_the_direct_link_below_to(inputs)
	if (locale === "id") return id_use_the_direct_link_below_to(inputs)
	if (locale === "it") return it_use_the_direct_link_below_to(inputs)
	if (locale === "ru") return ru_use_the_direct_link_below_to(inputs)
	if (locale === "pt") return pt_use_the_direct_link_below_to(inputs)
	return ko_use_the_direct_link_below_to(inputs)
});